"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importStar(require("react"));
const styles_1 = require("@material-ui/core/styles");
const Box_1 = __importDefault(require("../Box"));
const spacingMapping_1 = __importDefault(require("../../config/spacingMapping"));
const useStyles = styles_1.makeStyles({
    root: {
        marginTop: '-10px',
        '&>*': {
            marginTop: '10px',
        },
    },
});
/**
 * Renders components horizontally with consistent spacing between them.
 */
const Inline = (_a) => {
    var { children, spacing = 'm' } = _a, props = __rest(_a, ["children", "spacing"]);
    const styles = useStyles();
    const stackItems = react_1.Children.toArray(children).filter((c) => c);
    const lastIndex = stackItems.length - 1;
    const testId = props['data-testid'] || 'layout-inline';
    return (react_1.default.createElement(Box_1.default, { display: "flex", flexDirection: "row", flexWrap: "wrap", className: styles.root, "data-testid": testId }, stackItems.map((child, index) => (react_1.default.createElement(Box_1.default, { key: index, mr: index === lastIndex ? 'undefined' : spacingMapping_1.default[spacing] }, child)))));
};
exports.default = Inline;
//# sourceMappingURL=index.js.map